<template>
  <div id="slide-2" class="slide">
    <img src="../assets/images/tube-line.svg" alt="tube-line" class="line-img tube-line">
    <img src="../assets/images/mobile-line-1.svg" alt="mobile-line-1" class="mobile-line-img mobile-line">

    <div class="container slide-content">
      <div class="row">
        <div class="col-md-8 offset-md-1 col-sm-12">
          <h1 class="is-pink mb-3">Thanks!</h1>
          <label class="question-label my-2" for="end-station">Now where does your journey end?</label>
          <div class="input-group autoselect-group" @keyup.enter="changeSlide(nextSlide)">
            <v-autocomplete
              :items="items"
              v-model="item"
              @update-items="updateItems"
              @item-selected="itemSelected"
              :min-len="2"
              :get-label="getLabel"
              :component-item="AutocompleteItemTemplate"
              :auto-select-one-item="false"
              :input-attrs="{name: 'end-station', class: 'form-control', id: 'end-station'}">
            </v-autocomplete>
            <div class="input-group-append">
              <button class="btn btn-purple" type="button" @click="changeSlide(nextSlide)">Next</button>
            </div>
          </div>
          <p class="error-message" v-if="error" v-text="errorLabel"></p>
        </div>
      </div>
    </div>

    <div class="mob-line-wrap">
      <img src="../assets/images/mobile-line-2.svg" alt="mobile-line-2" class="mobile-line-img mobile-line-2">
    </div>

  </div>
</template>

<script>
import { autocomplete } from './../mixins/autocomplete';

export default {
  mixins: [ autocomplete ],
  props: ['talkLondon', 'stationFrom'],
  data () {
    return {
      error: false,
      errorLabel: ''
    }
  },
  computed: {
    nextSlide() {
      return this.talkLondon ? 6 : 4;
    }
  },
  methods: {
    itemSelected (item) {
      if (this.isSelectionValid(item)) {
        this.$emit('stationSelected', item);
        this.$ga.event('FA - data journey', 'Station to', item.name);
      }
    },

    changeSlide(i) {
      if (this.isSelectionValid(this.item)) {
        this.$emit('changeSlide', i);
        this.$ga.event('FA - data journey', 'Slide 2', 'Passed');
      }
    },

    isSelectionValid(item) {
      if (! item) {
        this.error = true;
        this.errorLabel = 'Please select the Tube station where your journey ends from the list.';
        return false;
      } else if (item.name === this.stationFrom.name) {
        this.error = true;
        this.errorLabel = 'Please select a Tube station that is different from your departure station.';
        return false;
      }
      this.error = false;
      return true;
    }
  }
}
</script>

<style lang="scss" scoped>
  .tube-line {
    position: absolute;
    right: 0;
    top: 220px;
  }

  .mobile-line {
    position: absolute;
    top: -70px;
    right: 0px;
  }

  .mob-line-wrap {
    position: relative;
    margin-top: 70px;
    height: 180px;
  }

  .mobile-line-2 {
    position: absolute;
    right: 0;
  }

  @media screen and (max-width: 900px) {
    .tube-line {
      right: -150px;
      top: 120px;
    }
  }

  @media screen and (max-width: 767px) {
    .slide-content {
      margin-top: 110px;
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/Slide2.vue